import React, { Component } from 'react';
import { connect } from 'react-redux'
import { bindActionCreators } from 'redux';


import { Table, Icon } from 'antd';
import adminColumns from '../../../../../utils/table-admins-columns';
import SearchFilter from '../../../../components/search-filter/search-filter';

import { filterSearch, getListUsers } from '../../admin.actions'

import './list.css'
import Add from '../add/add';


class ListAdmin extends Component {

  constructor(props) {
    super(props);
    this.state = {
      dataSource: [],
      changeModal: false
    }

    this.updateData = this.updateData.bind(this)
  }

  openModal = () => {
    this.setState({
        changeModal: true
    })
  }

  componentDidMount() {
    this.props.getListUsers()
    this.setState({
      dataSource: this.props.admin.listCoachs
    })
  }

  componentWillReceiveProps(nextProps) {
    if (nextProps.admin.listCoachs) {
      this.setState({ dataSource: nextProps.admin.listCoachs })
    }
  }

  updateData(array = this.state.dataSource) {
    this.setState({ dataSource: array })
  }

  render() {
    const { listCoachs, searchInput, inRequest } = this.props.admin;
    return inRequest ? <Icon type='sync' spin={inRequest} className="list-users icon-value" /> :
      <section className='listUsers'>
        <h2 className='ant-card-head-title'> Informações de Usuário </h2>
        <div className='listUsers-info'>
          <SearchFilter updateData={this.updateData} dataSource={listCoachs} onChange={this.props.filterSearch} searchInput={searchInput} />
          <button className='add-user' onClick={this.openModal}>
            <span> Adicionar Novo Usuário</span>
          </button>
        </div>
        <section className='table stats'>
          <Table columns={adminColumns} dataSource={this.state.dataSource} />
        </section>


        <Add {...this.props} isOpen={this.state.changeModal} onClose={() => this.setState({changeModal: false})}/>
      
      </section>

  }
}

const mapStateToProps = state => ({
  admin: state.admin
})

const mapDispatchToProps = dispatch => bindActionCreators({ filterSearch, getListUsers }, dispatch)


export default connect(mapStateToProps, mapDispatchToProps)(ListAdmin)



// WEBPACK FOOTER //
// ./src/App/containers/admin/sections/list/list.js